import type { ExamType } from "@/types/models";

export const EXAM_TYPE_OPTIONS: { value: ExamType; label: string }[] = [
  { value: "klassenarbeit", label: "Klassenarbeit" },
  { value: "klausur", label: "Klausur" },
  { value: "praesentation", label: "Präsentation" },
  { value: "muendliche_pruefung", label: "Mündliche Prüfung" },
  { value: "hausarbeit", label: "Hausarbeit" },
  { value: "sonstiges", label: "Sonstiges" },
];

export const EXAM_TYPE_SELECT_OPTIONS = [
  { value: "", label: "Keine Prüfungsform" },
  ...EXAM_TYPE_OPTIONS,
];

/** Vor der Umstellung vergebene Formen – nur noch für die Anzeige alter Themen. */
const LEGACY_LABEL: Record<string, string> = {
  aufsatz: "Aufsatz",
  test: "Test",
  projekt: "Projekt",
};

export function examTypeLabel(value?: string): string {
  if (!value) return "";
  return (
    EXAM_TYPE_OPTIONS.find((option) => option.value === value)?.label ??
    LEGACY_LABEL[value] ??
    "Prüfung"
  );
}
